<template>
  <div class="py-1.5 px-4 text-secondary text-style-sm font-medium">
    {{ title || t("components.sort_by.label") }}
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>
